import { translate } from "app/filters/i18nFilter";

import type { PrimitiveListCellValue } from "../types";

const MAX_LIST_LENGTH = 10;
export const createPrimitiveListCellTooltipContent = (
    value: readonly PrimitiveListCellValue[],
    maxListLength: number = MAX_LIST_LENGTH,
): string => {
    let tooltipContent = value.slice(0, maxListLength).join(",\n");

    if (value.length > 10) {
        tooltipContent += `\n${translate("si.common.table.column.content.more", { count: value.length - maxListLength })}`;
    }

    return tooltipContent;
};
